import _objectWithoutProperties from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import PropTypes from 'prop-types';
import { Animated, View, StyleSheet } from 'react-native';
import TabBar from './TabBar';
import PagerDefault from './PagerDefault';
import { NavigationStatePropType } from './PropTypes';

var TabView =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TabView, _React$Component);

  function TabView(_props) {
    var _this;

    _classCallCheck(this, TabView);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TabView).call(this, _props));

    _defineProperty(_assertThisInitialized(_this), "_mounted", false);

    _defineProperty(_assertThisInitialized(_this), "_renderScene", function (props) {
      return _this.props.renderScene(props);
    });

    _defineProperty(_assertThisInitialized(_this), "_handleLayout", function (e) {
      var _e$nativeEvent$layout = e.nativeEvent.layout,
          height = _e$nativeEvent$layout.height,
          width = _e$nativeEvent$layout.width;

      if (_this.state.layout.width === width && _this.state.layout.height === height) {
        return;
      }

      _this.state.panX.setValue(0);

      _this.state.offsetX.setValue(-_this.props.navigationState.index * width);

      _this.state.layoutXY.setValue({
        // This is hacky, but we need to make sure that the value is never 0
        x: width || 0.001,
        y: height || 0.001
      });

      _this.setState({
        layout: {
          measured: true,
          height: height,
          width: width
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_buildSceneRendererProps", function () {
      return {
        panX: _this.state.panX,
        offsetX: _this.state.offsetX,
        position: _this.state.position,
        layout: _this.state.layout,
        navigationState: _this.props.navigationState,
        jumpTo: _this._jumpTo,
        useNativeDriver: _this.props.useNativeDriver === true
      };
    });

    _defineProperty(_assertThisInitialized(_this), "_jumpTo", function (key) {
      if (!_this._mounted) {
        // We are no longer mounted, this is a no-op
        return;
      }

      var _this$props = _this.props,
          canJumpToTab = _this$props.canJumpToTab,
          navigationState = _this$props.navigationState;
      var index = navigationState.routes.findIndex(function (route) {
        return route.key === key;
      });

      if (!canJumpToTab(navigationState.routes[index])) {
        return;
      }

      if (index !== navigationState.index) {
        _this.props.onIndexChange(index);
      }
    });

    var _navigationState = _this.props.navigationState;

    var layout = _objectSpread({}, _this.props.initialLayout, {
      measured: false
    });

    var panX = new Animated.Value(0);
    var offsetX = new Animated.Value(-_navigationState.index * layout.width);
    var layoutXY = new Animated.ValueXY({
      // This is hacky, but we need to make sure that the value is never 0
      x: layout.width || 0.001,
      y: layout.height || 0.001
    });
    var position = Animated.multiply(Animated.divide(Animated.add(panX, offsetX), layoutXY.x), -1);
    _this.state = {
      layout: layout,
      layoutXY: layoutXY,
      panX: panX,
      offsetX: offsetX,
      position: position,
      renderUnfocusedScenes: false
    };
    return _this;
  }

  _createClass(TabView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this._mounted = true; // Delay rendering of unfocused scenes for improved startup

      setTimeout(function () {
        return _this2.setState({
          renderUnfocusedScenes: true
        });
      }, 0);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          navigationState = _this$props2.navigationState,
          onIndexChange = _this$props2.onIndexChange,
          initialLayout = _this$props2.initialLayout,
          renderScene = _this$props2.renderScene,
          renderPager = _this$props2.renderPager,
          renderTabBar = _this$props2.renderTabBar,
          tabBarPosition = _this$props2.tabBarPosition,
          rest = _objectWithoutProperties(_this$props2, ["navigationState", "onIndexChange", "initialLayout", "renderScene", "renderPager", "renderTabBar", "tabBarPosition"]);

      var props = this._buildSceneRendererProps();

      return React.createElement(View, {
        collapsable: false,
        style: [styles.container, this.props.style]
      }, tabBarPosition === 'top' && renderTabBar(props), React.createElement(View, {
        onLayout: this._handleLayout,
        style: styles.pager
      }, renderPager(_objectSpread({}, props, {}, rest, {
        panX: this.state.panX,
        offsetX: this.state.offsetX,
        children: navigationState.routes.map(function (route, index) {
          var isFocused = _this3.props.navigationState.index === index;
          var scene;

          if (isFocused || _this3.state.renderUnfocusedScenes) {
            scene = _this3._renderScene(_objectSpread({}, props, {
              route: route
            }));
          } else {
            scene = React.createElement(View, null);
          }

          if (React.isValidElement(scene)) {
            /* $FlowFixMe: https://github.com/facebook/flow/issues/4775 */
            scene = React.cloneElement(scene, {
              key: route.key
            });
          }

          return scene;
        })
      }))), tabBarPosition === 'bottom' && renderTabBar(props));
    }
  }]);

  return TabView;
}(React.Component);

_defineProperty(TabView, "propTypes", {
  navigationState: NavigationStatePropType.isRequired,
  onIndexChange: PropTypes.func.isRequired,
  initialLayout: PropTypes.shape({
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired
  }),
  canJumpToTab: PropTypes.func.isRequired,
  renderPager: PropTypes.func.isRequired,
  renderScene: PropTypes.func.isRequired,
  renderTabBar: PropTypes.func,
  tabBarPosition: PropTypes.oneOf(['top', 'bottom'])
});

_defineProperty(TabView, "defaultProps", {
  canJumpToTab: function canJumpToTab() {
    return true;
  },
  tabBarPosition: 'top',
  renderTabBar: function renderTabBar(props) {
    return React.createElement(TabBar, props);
  },
  renderPager: function renderPager(props) {
    return React.createElement(PagerDefault, props);
  },
  getTestID: function getTestID(_ref) {
    var route = _ref.route;
    return typeof route.testID === 'string' ? route.testID : undefined;
  },
  initialLayout: {
    height: 0,
    width: 0
  },
  useNativeDriver: false
});

export { TabView as default };
var styles = StyleSheet.create({
  container: {
    flex: 1,
    overflow: 'hidden'
  },
  pager: {
    flex: 1
  }
});